export function extractCommaSeparatedValues(csv: string): Array<string> {
  return csv
    .trim()
    .split(",")
    .map((e: string) => e.trim());
}

export const genericStringSplitter = (str = "") =>
  str.split(/(?:,|\s|\n|\t)+/g).filter((token) => token !== "");

export const capitalize = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1, str.length);

export const snakeToCapitalCase = (str: string) =>
  str
    .split("_")
    .map((v) => capitalize(v))
    .join(" ");
